import firebase from "../services/FirebaseService";

class ArticleService {
	
	async addNewArticle(content) {

		if(content.length < 100) {
			throw new Error("Please write at least 100 characters");
		}
		else {
			
			let id;
			
			try {
				const results = await firebase.firestore().collection("articles").add({
					date: new Date(),
					content: content
				});
	
				id = results.id;
				
				return id;
			}
			catch {
				throw new Error("An issue has occured, please try again later.");
			}
		}
	}
	async fetchArticles() {

		const articles = [];

		try {

			const results = await firebase.firestore().collection("articles").orderBy("date", "desc").get();
			const docs = results.docs;
		
			for(let i = 0; i < docs.length; i++) {
			
				articles.push({
					id: docs[i].id,
					date: docs[i].get("date").toDate(),
					content: docs[i].get("content")
				});
			}
	
			return articles;
		}
		catch(error) {
			throw new Error("An error has occured, please try again later");
		}
	}

	async fetchArticle(id) {

		try {

			const result = await firebase.firestore().collection("articles").doc(id).get();
			
			let article = {
				date: result.get("date").toDate(),
				content: result.get("content"),
			}
	
			return article;
		}
		catch(error) {
			throw new Error("An error has occured, please try again later");
		}
	}

}

export default ArticleService;